import { ReactNode } from 'react';

/**
 * Themed "no data" empty state — a violet illustration (gradient table + magnifier)
 * with a soft pulsing halo + gentle float, an entrance fade-up, a title and an
 * optional subtitle. Styles (`.sn-empty…`) live in
 * scss/components/salary-notice-page.style.scss (scoped under .salary-notice-page).
 */
export const EmptyState = ({
    title,
    subtitle,
}: {
    title: ReactNode;
    subtitle?: ReactNode;
}) => (
    <div className="sn-empty" role="status" aria-live="polite">
        <div className="sn-empty__art">
            <span className="sn-empty__halo" aria-hidden="true" />
            <svg className="sn-empty__illu" viewBox="0 0 64 64" fill="none" aria-hidden="true">
                <defs>
                    <linearGradient id="snEmptyGrad" x1="10" y1="12" x2="54" y2="22" gradientUnits="userSpaceOnUse">
                        <stop stopColor="#a855f7" />
                        <stop offset="1" stopColor="#7c3aed" />
                    </linearGradient>
                </defs>
                {/* table / card */}
                <rect x="10" y="12" width="44" height="40" rx="6" fill="#fff" stroke="#7c3aed" strokeOpacity="0.25" strokeWidth="2" />
                {/* gradient header strip */}
                <path d="M10 18a6 6 0 0 1 6-6h32a6 6 0 0 1 6 6v3H10z" fill="url(#snEmptyGrad)" />
                {/* empty placeholder rows */}
                <line x1="18" y1="30" x2="46" y2="30" stroke="#7c3aed" strokeOpacity="0.18" strokeWidth="3" strokeLinecap="round" strokeDasharray="2 5" />
                <line x1="18" y1="38" x2="40" y2="38" stroke="#7c3aed" strokeOpacity="0.18" strokeWidth="3" strokeLinecap="round" strokeDasharray="2 5" />
                <line x1="18" y1="46" x2="44" y2="46" stroke="#7c3aed" strokeOpacity="0.12" strokeWidth="3" strokeLinecap="round" strokeDasharray="2 5" />
                {/* magnifier */}
                <circle cx="44" cy="42" r="9" fill="#fff" stroke="#7c3aed" strokeWidth="2.5" />
                <line x1="50.5" y1="48.5" x2="56" y2="54" stroke="#7c3aed" strokeWidth="3" strokeLinecap="round" />
            </svg>
            <span className="sn-empty__dot sn-empty__dot--1" aria-hidden="true" />
            <span className="sn-empty__dot sn-empty__dot--2" aria-hidden="true" />
        </div>
        <p className="sn-empty__title">{title}</p>
        {subtitle ? <p className="sn-empty__subtitle">{subtitle}</p> : null}
    </div>
);
